import { images } from '../constants'; 

const blogs = [
    {
        id: 1,
        image: images.blog1,
        category: "Rental Tips",
        date: "24 July, 2025",
        admin: "Admin",
        heading: "Latest Car Models You Need to Know About",
        content: "Stay up-to-date with the latest car models and trends. Whether you're looking.",
        important: {
            content: "Explore expert insights on the latest cars to hit the market. From advanced features to sleek designs, these cars will make you rethink what you know about driving.",
            intro: "Automotive Expert"
        },
        paragraph: {
            para1: "The new models for 2025 come with cutting-edge technology, providing more safety features, better fuel efficiency, and enhanced comfort for every journey.",
            para2: "Whether you’re into electric vehicles or looking for a powerful sports car, this year’s lineup is filled with options to suit every taste.",
            para3: "Keep an eye on eco-friendly options as manufacturers push the envelope on electric and hybrid vehicles.",
            para4: "Don’t forget to check out the latest upgrades in interior design, infotainment systems, and autonomous driving capabilities."
        },
        gallery: [
            images.blog1Gallery1,
            images.blog1Gallery2
        ],
        tags: ["Tips", "Rental", "Car"],
        comments: [
            {
                id: 1,
                image: images.blog3Comment1,
                name: "Olivia Adams",
                date: "19 January, 2025",
                content: "I’ve been waiting for the latest electric vehicle releases, and this year looks promising! Can't wait to test them out.",
                replies: [
                    {
                        id: 1,
                        image: images.blog3Comment2,
                        name: "Michael Thompson",
                        date: "20 January, 2025",
                        content: "Same here! The new hybrid models are going to change the game."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog3Comment3,
                name: "Emma Williams",
                date: "21 January, 2025",
                content: "Great roundup of the newest cars. I’m definitely eyeing the new sports cars for 2025!"
            }
        ]
    },
    {
        id: 2,
        image: images.blog2,
        category: "Holiday Advice",
        date: "18 July, 2025",
        admin: "Admin",
        heading: "Car Rental Tips for the Holidays",
        content: "Renting a car this holiday? Get the best deals, avoid mistakes.",
        important: {
            content: "Holiday car rentals can be tricky with high demand and soaring prices. Follow our expert guidance to book smart, stay safe, and travel stress-free.",
            intro: "Holiday Travel Expert"
        },
        paragraph: {
            para1: "Book your rental as early as possible. Holiday seasons see a spike in demand, which drives up prices and limits availability. Early reservations give you better options at lower rates.",
            para2: "Compare rental providers across platforms like Expedia, Kayak, and direct websites. Watch for hidden fees like insurance, fuel charges, or underage driver surcharges.",
            para3: "Choose the right vehicle for your holiday plans—whether it's a compact car for city travel or an SUV for mountain roads. Also, consider fuel efficiency if you're going on long drives.",
            para4: "Inspect the car thoroughly before driving off and take photos. Make sure the rental agreement includes everything promised. Also, understand fuel policies to avoid extra charges."
        },
        gallery: [
            images.blog2Gallery1,
            images.blog2Gallery2
        ],
        tags: ["Holiday", "Tips", "Rental"],
        comments: [
            {
                id: 1,
                image: images.blog2Comment1,
                name: "Jason Miller",
                date: "23 January, 2025",
                content: "These tips are super useful! I once got hit with a surprise fuel charge—definitely checking policies more carefully next time.",
                replies: [
                    {
                        id: 1,
                        image: images.blog2Comment2,
                        name: "Laura Kim",
                        date: "24 January, 2025",
                        content: "Same here! Booking early also saved me a ton during New Year's travel last year."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog2Comment3,
                name: "Sophie Grant",
                date: "25 January, 2025",
                content: "I always forget to inspect the car before leaving. Thanks for the reminder!"
            }
        ]
    },
    {
        id: 3,
        image: images.blog3,
        category: "Car Checklist",
        date: "10 July, 2025",
        admin: "Admin",
        heading: "The Ultimate Car Rental Checklist",
        content: "Make your rental experience smooth with this complete car rental checklist.",
        important: {
            content: "Before you rent a car, it’s essential to prepare the right documents, inspect the vehicle thoroughly, and understand the rental terms. This checklist ensures you don’t miss a thing.",
            intro: "Rental Expert"
        },
        paragraph: {
            para1: "✔ **License & ID**: Always carry a valid driver’s license and a secondary form of ID (like a passport or national ID) when renting a car.",
            para2: "✔ **Payment Method**: Most rental companies require a credit card in the driver’s name. Some may accept debit cards, but check policies in advance.",
            para3: "✔ **Vehicle Inspection**: Examine the car for scratches, dents, or any existing damage. Take timestamped photos and videos before driving off.",
            para4: "✔ **Rental Agreement**: Read the terms carefully—especially regarding fuel policy, mileage limits, return location rules, and insurance coverage."
        },
        gallery: [
            images.blog3Gallery1,
            images.blog3Gallery2
        ],
        tags: ["Checklist", "Rental", "Travel"],
        comments: [
            {
                id: 1,
                image: images.blog3Comment1,
                name: "Brian Edwards",
                date: "27 January, 2025",
                content: "This is gold! I didn’t realize you could get charged for missing documentation. Now I’m always double-checking before I travel.",
                replies: [
                    {
                        id: 1,
                        image: images.blog3Comment2,
                        name: "Natalie Brooks",
                        date: "27 January, 2025",
                        content: "Same here—this checklist saved me when renting abroad!"
                    }
                ]
            },
            {
                id: 2,
                image: images.blog3Comment3,
                name: "Marcus Lee",
                date: "28 January, 2025",
                content: "The inspection tip is a must. Helped me avoid being charged for damage I didn’t cause."
            }
        ]
    },
    {
        id: 4,
        image: images.blog4,
        category: "Driving Rules",
        date: "03 July, 2025",
        admin: "Admin",
        heading: "Essential Driving Rules for Renting Cars",
        content: "Renting a car? Learn rules to avoid fines, stay safe, and protect rental.",
        important: {
            content: "Driving a rental car comes with responsibilities. From local laws to rental restrictions, make sure you follow these must-know rules to enjoy a hassle-free trip.",
            intro: "Driving Safety Advisor"
        },
        paragraph: {
            para1: "Follow all local traffic laws, including speed limits, traffic signals, and seatbelt requirements. Some countries have strict zero-tolerance policies for speeding or phone use while driving.",
            para2: "Never allow unauthorized drivers to use the rental car. Most companies only insure drivers listed on the rental agreement, and violating this can void your coverage.",
            para3: "Always obey parking rules—illegal parking can lead to fines that are charged back to you by the rental company, often with added administrative fees.",
            para4: "Know the alcohol limits in the region you're driving in. Even minor infractions can result in hefty penalties or disqualification from future rentals."
        },
        gallery: [
            images.blog4Gallery1,
            images.blog4Gallery2
        ],
        tags: ["Driving", "Rules", "Rental"],
        comments: [
            {
                id: 1,
                image: images.blog4Comment1,
                name: "Isabella Morgan",
                date: "30 January, 2025",
                content: "Great reminders! I once let a friend drive my rental and didn’t know it was against the rules. Won’t make that mistake again!",
                replies: [
                    {
                        id: 1,
                        image: images.blog4Comment2,
                        name: "Liam Harris",
                        date: "30 January, 2025",
                        content: "Good point! I always double-check the rental agreement now, especially when driving abroad."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog4Comment3,
                name: "Chloe Reed",
                date: "31 January, 2025",
                content: "Local parking laws caught me off guard once—definitely bookmarking this guide for future trips!"
            }
        ]
    },
    {
        id: 5,
        image: images.blog5,
        category: "Travel Planning",
        date: "28 June, 2025",
        admin: "Admin",
        heading: "Explore Your Desired Spots with Rental Cars",
        content: "Unlock adventures with rental cars—perfect for trips, hidden gems, and travel.",
        important: {
            content: "Rental cars offer the freedom to go beyond the usual tourist trails. Discover scenic routes, remote locations, and local favorites at your own pace.",
            intro: "Wanderlust Traveler"
        },
        paragraph: {
            para1: "Unlike public transport or guided tours, rental cars give you the flexibility to explore off-the-beaten-path locations, whether it's a quiet coastal road or a remote mountain village.",
            para2: "Build your own travel itinerary with stops you care about. Spend extra time at places you love and skip the crowded attractions that don’t interest you.",
            para3: "Driving lets you enjoy panoramic views, local eateries, and unplanned discoveries that often become the best part of the journey.",
            para4: "From national parks to hidden beaches, having your own car means spontaneous detours and immersive experiences are just a turn away."
        },
        gallery: [
            images.blog5Gallery1,
            images.blog5Gallery2
        ],
        tags: ["Travel", "Car", "Rental"],
        comments: [
            {
                id: 1,
                image: images.blog5Comment1,
                name: "Ethan Moore",
                date: "2 February, 2025",
                content: "I totally agree—some of my favorite spots were places I only found by car. Rental freedom is the way to go!",
                replies: [
                    {
                        id: 1,
                        image: images.blog5Comment2,
                        name: "Amelia Scott",
                        date: "2 February, 2025",
                        content: "Same here! My last trip to the countryside wouldn’t have been possible without a rental."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog5Comment3,
                name: "Daniel Green",
                date: "3 February, 2025",
                content: "This inspired me to plan a self-drive tour through Europe. Great ideas!"
            }
        ]
    },
    {
        id: 6,
        image: images.blog6,
        category: "Travel Planning",
        date: "20 June, 2025",
        admin: "Admin",
        heading: "Experience the Best Airport Transfer Service",
        content: "Start journey with airport transfers—designed for comfort and peace.",
        important: {
            content: "Airport transfer services ensure a smooth and timely transition between flights and accommodations. Whether you’re arriving or departing, enjoy premium vehicles and professional drivers.",
            intro: "Travel Comfort Consultant"
        },
        paragraph: {
            para1: "Avoid the hassle of waiting for taxis or navigating unfamiliar public transport. Airport transfer services offer timely pickups and drop-offs with professional drivers who know the area well.",
            para2: "Choose from a variety of vehicles—standard sedans, luxury cars, or spacious vans—based on your group size and comfort needs.",
            para3: "Most transfer services provide real-time flight tracking and adjust pickup times accordingly, ensuring you're not left stranded due to delays or early arrivals.",
            para4: "With fixed pricing, no surprise costs, and 24/7 availability, airport transfers provide peace of mind, especially for late-night or international flights."
        },
        gallery: [
            images.blog6Gallery1,
            images.blog6Gallery2
        ],
        tags: ["Travel", "Tips", "Car"],
        comments: [
            {
                id: 1,
                image: images.blog6Comment1,
                name: "Grace Taylor",
                date: "5 February, 2025",
                content: "I booked an airport transfer last minute and it was the smoothest part of my entire trip. Worth every penny!",
                replies: [
                    {
                        id: 1,
                        image: images.blog6Comment2,
                        name: "Lucas Price",
                        date: "5 February, 2025",
                        content: "Same! I’ll never go back to waiting in long taxi queues again."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog6Comment3,
                name: "Sophia Bennett",
                date: "6 February, 2025",
                content: "The driver was waiting with my name at arrival—felt like VIP treatment. Highly recommend airport transfers!"
            }
        ]
    },
    {
        id: 7,
        image: images.blog7,
        category: "Rental Tips",
        date: "14 June, 2025",
        admin: "Admin",
        heading: "How to Choose the Perfect Rental Car",
        content: "Choosing the right car can make or break trip. Match vehicle to needs.",
        important: {
            content: "From budget-friendly compacts to luxurious SUVs, choosing the right rental car depends on your destination, group size, and driving preferences. Use this guide to make an informed decision.",
            intro: "Rental Planning Specialist"
        },
        paragraph: {
            para1: "Start by assessing your trip purpose. A fuel-efficient compact is ideal for city exploring, while an SUV or 4x4 might be better for mountainous or rugged terrain.",
            para2: "Consider passenger and luggage space. Traveling with family or carrying multiple bags? Opt for a vehicle with ample room to avoid discomfort or overpacking.",
            para3: "Factor in fuel economy, especially for long-distance travel. Hybrid or diesel vehicles may offer better mileage, helping you save money during your trip.",
            para4: "Don’t forget to check for modern features like GPS, Bluetooth, backup cameras, and safety tech. These can improve your driving experience significantly."
        },
        gallery: [
            images.blog7Gallery1,
            images.blog7Gallery2
        ],
        tags: ["Travel", "Tips", "Car"],
        comments: [
            {
                id: 1,
                image: images.blog7Comment1,
                name: "Noah Jenkins",
                date: "8 February, 2025",
                content: "This was super helpful! I nearly chose a tiny car for a mountain trip—glad I double-checked.",
                replies: [
                    {
                        id: 1,
                        image: images.blog7Comment2,
                        name: "Lily Carter",
                        date: "8 February, 2025",
                        content: "I’ve made that mistake before! Now I always match the car to the route."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog7Comment3,
                name: "Zachary Hayes",
                date: "9 February, 2025",
                content: "Fuel economy tips were a lifesaver during my cross-country drive. Great blog!"
            }
        ]
    },
    {
        id: 8,
        image: images.blog8,
        category: "Holiday Advice",
        date: "06 June, 2025",
        admin: "Admin",
        heading: "Holiday Car Rental Advice You Need",
        content: "Planning a trip? Here's how to make car rental smooth and budget-friendly.",
        important: {
            content: "Renting a car during the holidays requires smart timing, careful planning, and understanding seasonal demand. These tips will help you avoid common pitfalls and enjoy your holiday getaway.",
            intro: "Seasonal Travel Expert"
        },
        paragraph: {
            para1: "Holiday seasons are peak times for car rentals. Book early to secure availability and better rates—last-minute bookings often mean higher prices and fewer options.",
            para2: "Look out for limited office hours during holidays. Confirm pickup and drop-off times with your rental agency in advance to avoid surprises.",
            para3: "Consider winter-friendly vehicles for holiday destinations in colder climates. Features like AWD, snow tires, or heated seats can make a big difference.",
            para4: "Keep an eye on special holiday surcharges, insurance add-ons, and mileage restrictions that rental companies may apply during peak travel periods."
        },
        gallery: [
            images.blog8Gallery1,
            images.blog8Gallery2
        ],
        tags: ["Tips", "Car", "Rental"],
        comments: [
            {
                id: 1,
                image: images.blog8Comment1,
                name: "Emily Foster",
                date: "11 February, 2025",
                content: "I didn’t realize rental offices close early on holidays—almost missed my car last year. Great tip!",
                replies: [
                    {
                        id: 1,
                        image: images.blog8Comment2,
                        name: "Logan Davis",
                        date: "11 February, 2025",
                        content: "Happened to me too! Now I always double-check hours before confirming."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog8Comment3,
                name: "Natalie Ross",
                date: "12 February, 2025",
                content: "These tips are perfect for my upcoming winter road trip—definitely getting a 4WD vehicle!"
            }
        ]
    },
    {
        id: 9,
        image: images.blog9,
        category: "Car Checklist",
        date: "22 May, 2025",
        admin: "Admin",
        heading: "Complete Checklist for Renting a Car",
        content: "First time or tenth, this checklist helps you rent a car confidently.",
        important: {
            content: "From documents to drop-off, don’t miss a step. This checklist covers everything you need to know to avoid hidden fees, misunderstandings, and last-minute stress.",
            intro: "Travel Logistics Coach"
        },
        paragraph: {
            para1: "✔ **Documents**: Bring a valid driver’s license, a second form of ID, and a credit card in the main driver’s name. International travelers may need an International Driving Permit (IDP).",
            para2: "✔ **Booking Confirmation**: Have a digital or printed copy of your reservation, along with the contact number for the rental agency in case of delays or questions.",
            para3: "✔ **Vehicle Inspection**: Check for damage, take photos/videos, verify tire condition, and test lights, indicators, and windshield wipers before leaving the lot.",
            para4: "✔ **Rental Agreement Review**: Carefully review fuel policies, mileage limits, insurance terms, return procedures, and any penalties for late returns or location changes."
        },
        gallery: [
            images.blog9Gallery1,
            images.blog9Gallery2
        ],
        tags: ["Checklist", "Car", "Rental"],
        comments: [
            {
                id: 1,
                image: images.blog9Comment1,
                name: "Anthony Rivera",
                date: "14 February, 2025",
                content: "This checklist saved me big time! I caught a scratch on the bumper before I drove off—avoided being blamed for it later.",
                replies: [
                    {
                        id: 1,
                        image: images.blog9Comment2,
                        name: "Julia Nguyen",
                        date: "14 February, 2025",
                        content: "Good call! I also bring a printed agreement just in case I lose internet access."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog9Comment3,
                name: "Ryan Barrett",
                date: "15 February, 2025",
                content: "Such a useful guide. I’ll be printing this before my trip next week. Thanks for sharing!"
            }
        ]
    },
    {
        id: 10,
        image: images.blog10,
        category: "Driving Rules",
        date: "16 May, 2025",
        admin: "Admin",
        heading: "Must-Know Driving Rules for Car Rentals",
        content: "Before driving rental, know rules to avoid fines and stay safe.",
        important: {
            content: "Driving in a new area can be tricky, especially when renting a car. These essential rules will help you stay legal, safe, and stress-free no matter where you drive.",
            intro: "International Driving Guide"
        },
        paragraph: {
            para1: "Know the local **speed limits**—they vary by country, city, and road type. GPS apps may help, but signs always take priority.",
            para2: "Understand **priority rules at intersections**, roundabouts, and pedestrian crossings. What’s normal at home might be illegal abroad.",
            para3: "Familiarize yourself with **road signs and markings** specific to the region. Some countries use symbols that differ from international standards.",
            para4: "Watch out for **rental-specific restrictions**, such as limits on border crossing, off-road driving, or age-related rules that vary between companies and countries."
        },
        gallery: [
            images.blog10Gallery1,
            images.blog10Gallery2
        ],
        tags: ["Driving", "Rules", "Rental"],
        comments: [
            {
                id: 1,
                image: images.blog10Comment1,
                name: "Ben Harrington",
                date: "17 February, 2025",
                content: "Super helpful—roundabouts work so differently in Europe than in the U.S. This saved me some major confusion.",
                replies: [
                    {
                        id: 1,
                        image: images.blog10Comment2,
                        name: "Elena Woods",
                        date: "17 February, 2025",
                        content: "Agreed! And don’t forget headlights rules—some countries require daytime lights even in summer."
                    }
                ]
            },
            {
                id: 2,
                image: images.blog10Comment3,
                name: "Derek Monroe",
                date: "18 February, 2025",
                content: "Didn’t realize I couldn’t take my rental across the border—thanks for highlighting that!"
            }
        ]
    }

];

export default blogs;